var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHome5(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 419,
    height: 94,
    viewBox: "0 0 419 94",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M138 0.105942L138 46.8513L184.668 46.8513L184.668 0.10593L138 0.105942Z",
    fill: "#FAFAFA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M184.607 -1.52588e-05L184.607 46.7454L231.275 46.7453L231.275 -2.75185e-05L184.607 -1.52588e-05Z",
    fill: "#FAFAFA"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M231.215 0.0610466L231.215 46.8064L277.883 46.8064L277.882 0.0610343L231.215 0.0610466Z",
    fill: "#2E2E2E"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M219.527 0.166042L231.152 11.8108L231.152 0.166039L219.527 0.166042Z",
    fill: "#D62340"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M207.901 0.166095L196.276 0.166098L231.152 35.1003L231.152 23.4556L207.901 0.166095Z",
    fill: "#D62340"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M184.651 0.166364L231.152 46.7454L219.527 46.7454L184.651 11.8111L184.651 0.166364Z",
    fill: "#D62340"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M184.651 23.4559L207.901 46.7454L196.276 46.7454L184.651 35.1006L184.651 23.4559Z",
    fill: "#D62340"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M161.28 0.102852L138.028 23.3933L161.28 46.6838L184.532 23.3933L161.28 0.102852Z",
    fill: "#2E2E2E"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M277.82 46.7444L254.569 23.4549L277.82 0.165375L277.82 46.7444Z",
    fill: "#FAFAFA"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M418.28 46.8069L418.28 0.0615234L371.612 0.0615357L371.612 46.8069L418.28 46.8069Z",
    fill: "#2E2E2E"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M418.325 0.0904234L395.074 23.3799L418.325 46.6694L418.325 0.0904234Z",
    fill: "#FAFAFA"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M325.12 46.8518L325.12 0.106445L278.452 0.106458L278.452 46.8518L325.12 46.8518Z",
    fill: "#D62340"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M371.727 46.7913L371.727 0.0458984L325.059 0.0459107L325.059 46.7913L371.727 46.7913Z",
    fill: "#2E2E2E"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M348.431 11.6749C342.011 11.6749 336.806 16.8884 336.806 23.3196C336.806 29.7508 342.011 34.9644 348.431 34.9644C354.852 34.9644 360.057 29.7508 360.057 23.3196C360.057 16.8884 354.852 11.6749 348.431 11.6749Z",
    fill: "#FAFAFA"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M301.764 35.1309C295.287 35.1309 290.138 29.9739 290.138 23.4861C290.138 16.9983 295.287 11.8414 301.764 11.8414C308.241 11.8414 313.389 16.9983 313.389 23.4861C313.389 29.8075 308.241 35.1309 301.764 35.1309Z",
    fill: "#FAFAFA"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M324.693 47.03L324.693 93.7754L371.36 93.7754L371.36 47.03L324.693 47.03Z",
    fill: "#FAFAFA"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M371.3 46.9241L371.3 93.6694L417.968 93.6694L417.968 46.924L371.3 46.9241Z",
    fill: "#FAFAFA"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M406.22 47.0901L417.845 58.7349L417.845 47.0901L406.22 47.0901Z",
    fill: "#D62340"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M394.594 47.0902L382.969 47.0902L417.845 82.0244L417.845 70.3797L394.594 47.0902Z",
    fill: "#D62340"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M371.343 47.0904L417.845 93.6694L406.22 93.6694L371.343 58.7352L371.343 47.0904Z",
    fill: "#D62340"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M371.343 70.3799L394.594 93.6694L382.968 93.6694L371.343 82.0247L371.343 70.3799Z",
    fill: "#D62340"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M347.973 47.0269L324.721 70.3174L347.973 93.6079L371.225 70.3174L347.973 47.0269Z",
    fill: "#2E2E2E"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome5);
export default __webpack_public_path__ + "static/media/home5.f912ae1d9d26f0329e27caee43bc28ae.svg";
export { ForwardRef as ReactComponent };